module.exports = __webpack_public_path__ + "static/img/16.b0c5281.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/04/16.jpeg
// module id = dFw4
// module chunks = 7